import { makeStyles, Theme } from '@material-ui/core';
import React from 'react';

import { GetLoggedInUserQuery } from '../../../graphql/gen/types';
import { NavBar } from '../navigation/NavBar';
import { SearchResultsPage } from '../search/SearchResultsPage';
import { FeedContainer } from './FeedContainer';
import { FilterLeftNavBar } from './NavBar/FilterLeftNavBar';

interface Props {
  userProfile: NonNullable<GetLoggedInUserQuery['currentUser']>;
}

export function PlexFeed({ userProfile }: Props): React.ReactElement {
  const classes = useStyles();

  return (
    <React.Fragment>
      <NavBar />
      <div className={classes.contentWrapper}>
        <div className={classes.content}>
          <div className={classes.root}>
            <FilterLeftNavBar userProfile={userProfile} />
            <div className={classes.feed}>
              <SearchResultsPage />
              <FeedContainer />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    overflowY: 'hidden',
    overflowX: 'auto',
    height: '100vh',
    width: '100%',
    paddingTop: 80,
  },
  feed: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    flex: 1,
  },
  contentWrapper: {
    backgroundColor: '#F6F6F6',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
  },
}));
